export enum TIME_REQUEST_STATUSES {
    CREATED = "created",
    PAID = "paid",
    WAITING_FOR_RESPONSE = "waiting",
    ACCEPTED = "accepted",
    REJECTED = "rejected",
    CANCELLED = "cancelled",
    CANCELLED_NO_ANSWER = "cancelled_no_answer",
    CANCELLED_WITHOUT_PAYMENT = "cancelled_without_payment",
    ERROR = "ERROR",
}

export const timeRequestStatusesSuccess = [
    TIME_REQUEST_STATUSES.PAID,
    TIME_REQUEST_STATUSES.ACCEPTED,
    TIME_REQUEST_STATUSES.WAITING_FOR_RESPONSE,
    TIME_REQUEST_STATUSES.CANCELLED,
    TIME_REQUEST_STATUSES.CANCELLED_NO_ANSWER,
    TIME_REQUEST_STATUSES.REJECTED,
]
